<template>
  <div class="m-index-ordos">
    <!-- 顶部栏：logo + 登录 -->
    <div class="ordos-m-header">
      <img
        class="ordos-m-header__logo"
        :src="theme.mLogo"
        :alt="theme.logoAlt"
      />
      <div class="ordos-m-header__nav">
        <img
          v-if="userInfo"
          class="ordos-m-header__avatar"
          :src="userInfo.avatar || require('@/assets/head-default-personal.png')"
          @click="$router.push('/userCenter')"
        />
        <span v-else class="ordos-m-header__login" @click="ShowMLoginModal">登录</span>
      </div>
    </div>

    <!-- 首屏：有 heroVideo 播视频，否则用 banner 图 -->
    <div class="ordos-m-hero">
      <video
        v-if="theme.heroVideo"
        ref="heroVideo"
        class="ordos-m-hero__video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline="true"
        x5-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="false"
        preload="auto"
        :src="theme.heroVideo"
        :poster="theme.banner"
        @loadeddata="playHeroVideo"
        @canplay="playHeroVideo"
      ></video>
      <img
        v-else
        class="ordos-m-hero__banner"
        :src="theme.banner"
        :alt="theme.bannerAlt"
      />
    </div>

    <div
      class="ordos-m-content"
      :style="{ backgroundImage: 'url(' + theme.bg + ')' }"
    >
      <!-- 金刚区菜单 -->
      <div class="ordos-m-menu" v-if="menuList && menuList.length">
        <div
          v-for="menu in menuList.slice(0, 5)"
          :key="menu.name"
          class="ordos-m-menu__item"
          @click="menuIconClick(menu)"
        >
          <img :src="menu.icon" class="ordos-m-menu__icon" alt="" />
          <p class="ordos-m-menu__title">{{ menu.name }}</p>
        </div>
      </div>

      <!-- Banner 轮播 -->
      <swiper
        class="ordos-m-banner"
        ref="bannerSwiper"
        :options="swiperOptionsBanner"
        v-if="bannerList.length"
      >
        <swiper-slide
          v-for="(item, index) in bannerList"
          :key="item.image + '_' + index"
        >
          <img v-if="!item.link" class="ordos-m-banner__img" :src="item.image" />
          <a :href="item.link" v-else>
            <img class="ordos-m-banner__img" :src="item.image" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <!-- 主体内容 -->
      <div class="ordos-m-body">
        <div class="ordos-m-load" v-if="loadingState">
          <div class="ordos-m-load__title"></div>
          <div class="ordos-m-load__tabs">
            <span></span>
            <span></span>
          </div>
          <div class="ordos-m-load__grid">
            <p></p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>

        <div
          v-for="group in ordosModuleGroups"
          :key="group.key"
          :id="'ordos-module-' + group.key"
          class="ordos-m-module"
        >
          <div
            class="ordos-m-module__head"
            :class="{ 'ordos-m-module__head--with-more': group.hideTabs }"
          >
            <div class="ordos-m-module__head-main">
              <p class="ordos-m-module__en" v-if="group.en">{{ group.en }}</p>
              <p class="ordos-m-module__cn">
                <span class="ordos-m-module__power">{{ group.powerName }}</span>
                <span class="ordos-m-module__sub" v-if="group.subTitle">{{ group.subTitle }}</span>
              </p>
            </div>
            <span
              v-if="group.hideTabs && getActiveModule(group)"
              class="ordos-m-module__more ordos-m-module__more--inline"
              @click="goOrdosMore(group)"
            >查看更多 &gt;</span>
          </div>

          <div class="ordos-m-module__tabs" v-if="!group.hideTabs">
            <span
              v-if="group.basic"
              class="ordos-m-tab"
              :class="{ 'ordos-m-tab--active': getOrdosTab(group.key) === 'basic' }"
              @click="setOrdosTab(group.key, 'basic')"
            >基础课程</span>
            <span
              v-if="group.advanced"
              class="ordos-m-tab"
              :class="{ 'ordos-m-tab--active': getOrdosTab(group.key) === 'advanced' }"
              @click="setOrdosTab(group.key, 'advanced')"
            >进阶课程</span>
          </div>

          <transition name="ordos-m-switch" mode="out-in">
            <ul
              v-if="getActiveModule(group)"
              :key="group.key + '-' + getOrdosTab(group.key)"
              class="ordos-m-course-list"
              :class="{
                'ordos-m-course-list--multi': getOrdosCourseLimit(group) > 4,
                'ordos-m-course-list--image-only': group.hideTabs,
              }"
            >
              <li
                v-for="subItem in (getActiveModule(group).list || []).slice(0, getOrdosCourseLimit(group))"
                :key="subItem.id"
                class="ordos-m-course-item"
              >
                <a href="javascript:;" @click.prevent="goOrdosCourse(group, subItem)">
                  <div class="ordos-m-course-item__img">
                    <img v-lazy="subItem.image" :key="subItem.image" alt="" />
                  </div>
                  <div class="ordos-m-course-item__title" v-if="!group.hideTabs">
                    <p>{{ subItem.name }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </transition>

          <div
            class="ordos-m-module__more"
            v-if="!group.hideTabs && getActiveModule(group)"
            @click="goOrdosMore(group)"
          >查看更多 &gt;</div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <div class="ordos-m-footer">
      <p>Copyright◎ 2015-2026 kjcxchina.com All Rights Reserved｜京ICP备16012224号 技术支持：中工科创</p>
    </div>

    <div class="loading" v-if="loadingState">
      <div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- 全国工匠学院作业提示弹框 -->
    <div v-if="taskHintDialog" class="taskHint-dialog">
      <div class="taskHint-content">
        <i class="el-icon-close close" @click="taskHintDialog = false"></i>
        <div class="taskHint-img">
          <img src="@/assets/m/lmxy_icon_m.png" alt="">
        </div>
        <div class="taskHint-text">
          <p class="title">作业提示</p>
          <p class="text">完成全部课程学习后，需要点击按钮"填写学习心得"进行填写或上传，截止日期为11月7日24时。</p>
          <a class="but" href="https://qggjxy.org.cn/userCenter" target="_self">填写学习心得</a>
        </div>
      </div>
    </div>
    <div v-if="taskHintDialog" class="maskSight-box"></div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getRequestHost } from "@/utils/axios";
import { getNmTheme } from "@/config/nmTheme";

export default {
  name: "IndexCf",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      menuList: [],
      menuAllList: [],
      bannerList: [],
      modulelist: [],
      loadingState: true,
      websiteData: "",
      siteInfo: {},
      taskHintDialog: false,
      ordosModuleMeta: [
        { en: "LEADERSHIP", power: "引领力" },
        { en: "ACHIEVEMENT POWER", power: "成就力" },
        { en: "CREATIVITY", power: "创新力" },
        { en: "CONCENTRATION", power: "专注力" },
        { en: "HERITAGE POWER", power: "传承力" },
      ],
      ordosModuleTab: {},
      swiperOptionsBanner: {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    theme() {
      // 域名优先选肤（getNmTheme/resolveNmSiteId），避免 localStorage 串站默认赤峰图
      const id = this.siteInfo && this.siteInfo.id;
      return getNmTheme(id) || {};
    },
    ordosModuleGroups() {
      const map = {};
      const order = ["引领力", "成就力", "创新力", "专注力", "传承力"];
      const extraGroups = [];

      this.modulelist.forEach((item) => {
        const styleId = Number(item.style_id);

        // style_id=6（2排8个 / 工匠专区）：不区分基础/进阶，最多展示 40 个
        if (styleId === 6) {
          extraGroups.push({
            key: item.name,
            powerName: item.name,
            subTitle: "",
            en: "",
            basic: item,
            advanced: null,
            hideTabs: true,
            courseLimit: 40,
          });
          return;
        }

        if (![1, 2, 3].includes(styleId)) return;

        const powerName = order.find((power) => item.name.indexOf(power) > -1);
        if (!powerName) return;

        const isBasic = /（基础）|\(基础\)|-基础课程/.test(item.name);
        const isAdvanced = /（进阶）|\(进阶\)|-进阶课程/.test(item.name);
        const baseName = item.name.replace(/（基础）|（进阶）|\(基础\)|\(进阶\)|-基础课程|-进阶课程/g, "").trim();
        const colonIdx = baseName.indexOf("：");
        const subTitle = colonIdx > -1 ? baseName.slice(colonIdx + 1).trim() : "";
        const meta = this.ordosModuleMeta.find((m) => m.power === powerName) || { en: "" };

        if (!map[powerName]) {
          map[powerName] = {
            key: powerName,
            powerName,
            subTitle,
            en: meta.en,
            basic: null,
            advanced: null,
          };
        }

        if (isBasic) map[powerName].basic = item;
        else if (isAdvanced) map[powerName].advanced = item;
        else if (!map[powerName].basic) map[powerName].basic = item;
        else map[powerName].advanced = item;
      });

      return order
        .filter((key) => map[key] && (map[key].basic || map[key].advanced))
        .map((key) => map[key])
        .concat(extraGroups);
    },
  },
  mounted() {
    this.GetUserInfo();
    this.getWebsiteInfo();
    this.getNeedLogin();
    this.getBenner();
    this.getModule();
    this.websiteData = this.$store.state.websiteState;

    if (this.$route.query.noncestr) {
      this.weLoin(this.$route.query.noncestr);
    }

    this.$nextTick(() => {
      this.initHeroVideo();
    });
  },
  beforeDestroy() {
    this.destroyHeroVideo();
  },
  watch: {
    "theme.heroVideo"(val) {
      if (val) {
        this.$nextTick(() => this.initHeroVideo());
      } else {
        this.destroyHeroVideo();
      }
    },
  },
  methods: {
    ...mapMutations(["ShowMLoginModal", "ShowTipModal", "CloseTipModal", "GetUserInfo"]),
    playHeroVideo() {
      const video = this.$refs.heroVideo;
      if (!video) return;
      video.muted = true;
      video.setAttribute("muted", "muted");
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    },
    initHeroVideo() {
      const video = this.$refs.heroVideo;
      if (!video || !this.theme.heroVideo) return;

      const tryPlay = () => this.playHeroVideo();

      if (typeof window.WeixinJSBridge === "object" && window.WeixinJSBridge.invoke) {
        window.WeixinJSBridge.invoke("getNetworkType", {}, tryPlay);
      } else {
        this._weixinBridgeReadyHandler = tryPlay;
        document.addEventListener("WeixinJSBridgeReady", this._weixinBridgeReadyHandler, false);
      }

      this._heroVideoTouchHandler = () => tryPlay();
      document.addEventListener("touchstart", this._heroVideoTouchHandler, { once: true, passive: true });
      document.addEventListener("click", this._heroVideoTouchHandler, { once: true });

      tryPlay();
    },
    destroyHeroVideo() {
      if (this._weixinBridgeReadyHandler) {
        document.removeEventListener("WeixinJSBridgeReady", this._weixinBridgeReadyHandler);
        this._weixinBridgeReadyHandler = null;
      }
      if (this._heroVideoTouchHandler) {
        document.removeEventListener("touchstart", this._heroVideoTouchHandler);
        document.removeEventListener("click", this._heroVideoTouchHandler);
        this._heroVideoTouchHandler = null;
      }
    },
    getOrdosTab(groupKey) {
      if (this.ordosModuleTab[groupKey]) {
        return this.ordosModuleTab[groupKey];
      }
      const group = this.ordosModuleGroups.find((g) => g.key === groupKey);
      if (group && group.basic) return "basic";
      return "advanced";
    },
    setOrdosTab(groupKey, tab) {
      this.$set(this.ordosModuleTab, groupKey, tab);
    },
    getActiveModule(group) {
      const tab = this.getOrdosTab(group.key);
      if (tab === "advanced" && group.advanced) return group.advanced;
      if (group.basic) return group.basic;
      return group.advanced;
    },
    getOrdosCourseLimit(group) {
      return group.courseLimit || 4;
    },
    getOrdosCourseLink(group, subItem) {
      const module = this.getActiveModule(group);
      if (module && Number(module.style_id) === 6) {
        return "/seriesLessonsInfo/" + subItem.data_id;
      }
      return "/recordedInfo/" + subItem.data_id;
    },
    isOrdosComingSoon(group) {
      const module = this.getActiveModule(group);
      return !!(module && Number(module.style_id) === 6);
    },
    goOrdosCourse(group, subItem) {
      if (this.isOrdosComingSoon(group)) {
        this.showComingSoonTip();
        return;
      }
      this.$router.push(this.getOrdosCourseLink(group, subItem));
    },
    goOrdosMore(group) {
      const module = this.getActiveModule(group);
      if (!module) return;
      if (Number(module.style_id) === 6) {
        this.showComingSoonTip();
        return;
      }
      this.$router.push("/courseShowList?id=" + module.id);
    },
    showComingSoonTip() {
      this.$message({
        message: "内容陆续上线中",
        type: "warning",
      });
    },
    normalizeOrdosPowerName(name) {
      const text = String(name || "")
        .replace(/（基础）|（进阶）|\(基础\)|\(进阶\)|-基础课程|-进阶课程/g, "")
        .trim();
      const powers = ["引领力", "成就力", "创新力", "专注力", "传承力"];
      const hit = powers.find((item) => text.indexOf(item) > -1);
      if (hit) return hit;
      const style6 = this.ordosModuleGroups.find(
        (g) => g.hideTabs && text.indexOf(g.key) > -1
      );
      if (style6) return style6.key;
      const colonIdx = text.indexOf("：");
      if (colonIdx > -1) return text.slice(0, colonIdx);
      return text;
    },
    scrollToOrdosModule(name) {
      const powerName = this.normalizeOrdosPowerName(name);
      this.$nextTick(() => {
        const el = document.getElementById("ordos-module-" + powerName);
        if (!el) return;
        const headerOffset = 88;
        const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top, behavior: "smooth" });
      });
    },
    menuIconClick(menu) {
      const power = this.normalizeOrdosPowerName(menu.name);
      const hitGroup = this.ordosModuleGroups.find((g) => g.key === power);
      if (hitGroup) {
        this.scrollToOrdosModule(hitGroup.key);
        return;
      }
      if (menu.url) {
        if (menu.url.includes("http")) {
          window.location.href = menu.url;
        } else {
          this.$router.push(menu.url);
        }
      }
    },
    getWebsiteInfo() {
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        this.siteInfo = res.data.site_info;
        if (res.data.site_info.id == 108) {
          if (Number(this.$route.query.studyProgress) >= 100) {
            if (!localStorage.getItem("taskHintDialog")) {
              this.taskHintDialog = true;
              localStorage.setItem("taskHintDialog", "true");
            }
          }
        }
        localStorage.setItem("siteInfo", JSON.stringify(res.data.site_info));
        localStorage.setItem("navigation", JSON.stringify(res.data.navigation));
        this.menuList = res.data.navigation;
        if (document.getElementById("titleName")) {
          document.getElementById("titleName").innerText = res.data.site_info.name;
        }
      });
    },
    getNeedLogin() {
      if (localStorage.getItem("needLogin")) {
        this.ShowMLoginModal();
        localStorage.removeItem("needLogin");
      }
    },
    getBenner() {
      this.$axios.post(`/v1/home/banner`, { type: "2" }).then((res) => {
        if (res.data.length == 1) {
          this.swiperOptionsBanner.loop = false;
        }
        this.bannerList = res.data;
      });
    },
    getModule() {
      this.$axios.post(`/v1/home/module`).then((res) => {
        if (res.data.length > 0) {
          this.getModuleData(res.data);
        } else {
          this.loadingState = false;
        }
      });
      this.$axios.post(`/v1/home/category`).then((res) => {
        if (res.code == 0) {
          this.menuAllList = (res.data || []).slice().reverse();
        }
      });
      this.$axios.post(`/v1/home/getStatus`, { host: getRequestHost() }).then((res) => {
        if (res.code == 0) {
          this.websiteData = res.data;
        }
      });
    },
    async getModuleData(moduleData) {
      this.modulelist = moduleData;

      for (let i = 0; i < moduleData.length; i++) {
        const moduleItem = moduleData[i];
        const params = { id: moduleItem.id };
        if (Number(moduleItem.style_id) === 6) {
          params.pre_page = 40;
        }
        let res = await this.$axios.post(`/v1/home/moduleData`, params);

        for (let j = 0; j < this.modulelist.length; j++) {
          if (res.data.total) {
            for (let o = 0; o < res.data.data.length; o++) {
              if (res.data.data[o].module_id == this.modulelist[j].id) {
                if (this.modulelist[j].list) {
                  this.$set(this.modulelist[j].list, o, res.data.data[o]);
                } else {
                  this.$set(this.modulelist[j], "list", []);
                  this.$set(this.modulelist[j].list, o, res.data.data[o]);
                }
              }
            }
          } else {
            for (let o = 0; o < res.data.length; o++) {
              if (res.data[o].module_id == this.modulelist[j].id) {
                if (this.modulelist[j].list) {
                  this.$set(this.modulelist[j].list, o, res.data[o]);
                } else {
                  this.$set(this.modulelist[j], "list", []);
                  this.$set(this.modulelist[j].list, o, res.data[o]);
                }
              }
            }
          }
        }
        this.loadingState = false;
      }
    },
    async weLoin(code) {
      await this.$axios
        .post(`/v1/px/login/getUserinfo`, { noncestr: code })
        .then((res) => {
          if (res.code == 0) {
            this.ShowTipModal({
              text: res.msg,
              ico: "success",
            });
            localStorage.setItem("auth", JSON.stringify(res.data.auth));
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("userInfo", JSON.stringify(res.data.user));
            localStorage.setItem("logoDate", Date.parse(new Date()) / 1000);
            this.GetUserInfo();
          } else {
            this.ShowTipModal({
              text: res.msg,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-index-ordos {
  min-height: 100vh;
  background: #fff;
  color: #333;
  overflow-x: hidden;
}

/* ===== 顶部栏 ===== */
.ordos-m-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 88px;
  padding: 0 28px;
  background: #fff;

  &__logo {
    height: 50px;
    width: auto;
    max-width: 420px;
    object-fit: contain;
  }

  &__nav {
    flex-shrink: 0;
  }

  &__login {
    display: block;
    font-size: 24px;
    font-weight: 600;
    color: #262626;
    line-height: 34px;
  }

  &__avatar {
    width: 54px;
    height: 54px;
    border-radius: 50%;
  }
}

/* ===== 首屏 Banner ===== */
.ordos-m-hero {
  width: 100%;
  height: 422px;
  overflow: hidden;
  background: #000;

  &__banner,
  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    display: block;
  }
}
.ordos-m-content {
  background-repeat: repeat-y;
  background-size: 100% auto;
  background-position: top center;
}
/* ===== 金刚区 ===== */
.ordos-m-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 56px 34px 56px;
  // background: #fff;

  &__item {
    width: 20%;
    text-align: center;
    margin-bottom: 0;
  }

  &__icon {
    width: 96px;
    height: 96px;
    display: block;
    margin: 0 auto;
  }

  &__title {
    margin: 10px 0 0;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* ===== Banner ===== */
.ordos-m-banner {
  box-sizing: border-box;
  width: auto;
  margin: 2px 32px 64px;
  padding: 0;
  overflow: hidden;
  &__img {
    width: 100%;
    height: 400px;
    display: block;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 16px 28px rgba(188, 0, 0, 0.14);
  }

  ::v-deep .swiper-pagination-bullet {
    width: 16px;
    height: 6px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }

  ::v-deep .swiper-pagination-bullet-active {
    width: 32px;
    background: #fff;
  }
}

/* ===== 主体内容区 ===== */
.ordos-m-body {
  padding: 34px 32px 46px;
}

/* ===== 骨架屏 ===== */
.ordos-m-load {
  margin-bottom: 48px;

  &__title {
    width: 260px;
    height: 40px;
    margin: 0 auto 24px;
    border-radius: 6px;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.06));
    background-size: 200% 100%;
    animation: ordosSkeleton 1.4s ease-in-out infinite;
  }

  &__tabs {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;

    span {
      flex: 1;
      height: 64px;
      border-radius: 32px;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.05));
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    p {
      height: 280px;
      border-radius: 8px;
      margin: 0;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.05));
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }
}

@keyframes ordosSkeleton {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ===== 模块 ===== */
.ordos-m-module {
  margin-bottom: 64px;

  &__head {
    text-align: center;
    margin-bottom: 64px;

    &--with-more {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      gap: 20px;
      margin-bottom: 40px;
    }
  }

  &__head-main {
    min-width: 0;
  }

  &__en {
    font-weight: 800;
    font-size: 28px;
    color: #DAB46F;
    line-height: 40px;
    margin: 0 0 8px;
  }

  &__cn {
    font-size: 0;
    line-height: 1.3;
    margin: 0;
  }

  &__power {
    font-weight: 800;
    font-size: 36px;
    color: #9E0506;
    line-height: 44px;
    margin-right: 12px;
  }

  &__sub {
    font-weight: normal;
    font-size: 28px;
    color: #8b0018;
    line-height: 34px;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 40px;
  }

  &__more {
    display: block;
    width: 168px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
    color: #9E0506;
    background: #ffe5e5;
    border-radius: 8px;
    margin: 52px auto 0;

    &--inline {
      display: inline-block;
      width: auto;
      height: auto;
      line-height: 44px;
      margin: 0;
      padding: 0;
      background: transparent;
      border-radius: 0;
      flex-shrink: 0;
      color: #666;
      font-size: 24px;
    }
  }
}

/* ===== Tab 切换 ===== */
.ordos-m-tab {
  flex: 0 0 180px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  background: #fff;
  border-radius: 36px;
  box-shadow: 0 2px 4px rgba(225, 222, 222, 0.5);
  cursor: pointer;
  user-select: none;
  transition: background 0.35s ease, color 0.35s ease, box-shadow 0.35s ease;

  &--active {
    color: #fff;
    background: linear-gradient(180deg, #CD0C0E 0%, #9E0506 100%);
    box-shadow: 0 6px 16px rgba(158, 5, 6, 0.35);
  }
}

/* ===== 课程 2x2 网格 ===== */
.ordos-m-course-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.ordos-m-course-item {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(70, 20, 20, 0.08);

  a {
    text-decoration: none;
    display: block;
  }

  &__img {
    width: 100%;
    height: 168px;
    overflow: hidden;
    background: #f0f0f0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__title {
    padding: 12px 14px 14px;

    p {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 34px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 62px;
    }
  }
}

/* ===== Tab 切换动画 ===== */
.ordos-m-switch-enter-active,
.ordos-m-switch-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.ordos-m-switch-enter,
.ordos-m-switch-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* ===== 页脚 ===== */
.ordos-m-footer {
  background: #8b0018;
  text-align: center;
  padding: 32px;

  p {
    font-weight: 400;
    font-size: 22px;
    color: #EAF4FE;
    line-height: 36px;
    margin: 0;
  }
}

/* ===== 加载动画 ===== */
.loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadEffect {
  width: 100px;
  height: 100px;
  position: relative;
}

.loadEffect span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9e0506;
  position: absolute;
  animation: load 1.04s ease infinite;
}

@keyframes load {
  0% { opacity: 1; }
  100% { opacity: 0.2; }
}

.loadEffect span:nth-child(1) { left: 0; top: 50%; margin-top: -8px; animation-delay: 0.13s; }
.loadEffect span:nth-child(2) { left: 10px; top: 10px; animation-delay: 0.26s; }
.loadEffect span:nth-child(3) { left: 50%; top: 0; margin-left: -8px; animation-delay: 0.39s; }
.loadEffect span:nth-child(4) { top: 10px; right: 10px; animation-delay: 0.52s; }
.loadEffect span:nth-child(5) { right: 0; top: 50%; margin-top: -8px; animation-delay: 0.65s; }
.loadEffect span:nth-child(6) { right: 10px; bottom: 10px; animation-delay: 0.78s; }
.loadEffect span:nth-child(7) { bottom: 0; left: 50%; margin-left: -8px; animation-delay: 0.91s; }
.loadEffect span:nth-child(8) { bottom: 10px; left: 10px; animation-delay: 1.04s; }

/* ===== 作业提示弹框 ===== */
.taskHint-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
  width: 600px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 36px;
    color: #999;
    cursor: pointer;
    z-index: 1;
  }

  .taskHint-img img {
    width: 100%;
    display: block;
  }

  .taskHint-text {
    padding: 30px 40px 40px;

    .title {
      font-size: 36px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
    }

    .text {
      font-size: 28px;
      color: #666;
      line-height: 40px;
      margin-bottom: 30px;
    }

    .but {
      display: block;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      background: #9e0506;
      color: #fff;
      font-size: 30px;
      border-radius: 8px;
      text-decoration: none;
    }
  }
}

.maskSight-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
</style>
